import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Zap, Clock, Shield } from 'lucide-react';

const CTASection = () => {
  return (
    <section className="section bg-gradient-to-b from-[#0A0A0F] to-[#12121A]" id="cta">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          {/* Decorative element */}
          <div className="w-20 h-1 bg-gradient-to-r from-[#FF6B35] to-[#00D4FF] mx-auto mb-8 rounded-full" />
          
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">
            Stop Losing Plays.<br />
            <span className="gradient-text">Start Converting Traffic.</span>
          </h2>
          <p className="text-lg text-[#B8B8C0] mb-10 max-w-xl mx-auto">
            Your followers are waiting to become your customers. Let's build the website that makes it happen.
          </p>
          
          <Link 
            to="/contact"
            className="btn-accent text-lg px-8 py-4 animate-glow"
          >
            Get Your Free Quote
            <ArrowRight size={20} />
          </Link>
          
          {/* Reassurance points */}
          <div className="flex flex-wrap justify-center gap-6 mt-12">
            <div className="flex items-center gap-2 text-[#B8B8C0]">
              <Zap size={18} className="text-[#FF6B35]" />
              <span>Custom Quotes</span>
            </div>
            <div className="flex items-center gap-2 text-[#B8B8C0]">
              <Clock size={18} className="text-[#FF6B35]" />
              <span>24hr Response</span>
            </div>
            <div className="flex items-center gap-2 text-[#B8B8C0]">
              <Shield size={18} className="text-[#FF6B35]" />
              <span>No Obligation</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
